import React, { Component } from "react";
import EmailInput from "./EmailInput";
import { style } from "typestyle";

interface Props {
  value: string;
  onChange: (text: string) => void;
  onRemove: (event: any) => void;
}

interface State {
  value: string;
  isReadonlyMode: boolean;
}

export default class EditableItem extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      value: this.props.value,
      isReadonlyMode: true,
    };
  }

  componentWillReceiveProps() {
    this.setState({
      value: this.props.value,
    });
  }

  handleAddText = (text: string) => {
    this.setState({ isReadonlyMode: false });
    this.changeItem(text);
  };

  changeItem = (text: string) => {
    this.setState({ value: text, isReadonlyMode: true });
    this.props.onChange(text);
  };

  handleDoubleClick = (event: any) => {
    this.setState({ isReadonlyMode: false });
  };

  handleRemove = (event: any) => {
    if (confirm("Are you sure you want to delete this email?")) {
      this.props.onRemove(event);
    }
  };

  render() {
    const { isReadonlyMode } = this.state;
    return (
      <div
        className={wrapperInputReadonlyCN(isReadonlyMode)}
        onDoubleClick={this.handleDoubleClick.bind(this)}
      >
        {isReadonlyMode ? (
          <div className={style({ width: "100%", padding: "24px" })}>
            {this.state.value}
          </div>
        ) : (
          <EmailInput
            placeholder=""
            name={this.state.value}
            value={this.state.value}
            onAddText={this.handleAddText.bind(this)}
          />
        )}
        <div
          className={style({
            width: "62px",
            textAlign: "center",
            lineHeight: "72px",
            position: "absolute",
            right: "0",
          })}
          onClick={this.handleRemove.bind(this)}
        >
          <img src="./icon-close.svg" />
        </div>
      </div>
    );
  }
}

const wrapperInputReadonlyCN = (readonly: boolean = false) =>
  style({
    boxShadow: "inset 0px -1px 0px rgba(0, 0, 0, 0.08)",
    borderRadius: "0",
    lineHeight: "24px",
    border: "none",
    marginBottom: "0",
    fontSize: "20px",
    width: "391px",
    display: "flex",
    flexDirection: "row",
    cursor: "pointer",
    background: readonly ? "#FFFFFF" : "#F8F8FC",
    position: "relative",
  });
